<div class="main-content">
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <h2>
                        <span>
                            OOP'S
                        </span>
                        <br>
                        <small>The Page you are looking for is not found</small>
                    </h2>
                </div>
            </div>
        </div>
    </div>